import { Modal, Prompt, UtilityStyle } from '@administrate/piston-ux';
import {
  CallToActionCard,
  CategoryDropdown,
  ContentLocalePicker,
  ContextProvider,
  CourseDetails,
  Debug,
  EmbedBasket,
  EmbedCart,
  EmbedCategory,
  EmbedNavigation,
  EventList,
  PathDetails,
  SearchBar,
  setContentLocaleChangeHandler,
  TrainingRequest,
} from '@administrate/weblink';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import builderConfig from '../../config';
import { STORES } from '../../constants';
import { stores } from '../../weblinkProvider';
import inject from '../inject';

const CourseDetailsWrapper = ({ ...props }) => (
  <CourseDetails {...props} showBreadcrumb={false} />
);

const PathDetailsWrapper = ({ ...props }) => (
  <PathDetails {...props} showBreadcrumb={false} />
);

const components = {
  Cart: EmbedCart,
  Debug,
  CourseDetails: CourseDetailsWrapper,
  PathDetails: PathDetailsWrapper,
  EventList,
  Basket: EmbedBasket,
  Catalogue: EmbedNavigation,
  Category: EmbedCategory,
  SearchBar,
  CategoryDropdown,
  ContentLocalePicker,
  CallToActionCard,
  TrainingRequest,
};

const { STORE_PREVIEW, STORE_CONFIG, STORE_APOLLO } = STORES;

const PreviewModal = ({
  [STORE_PREVIEW]: {
    closeModal,
    widget: { name, id, props },
    show,
  },
  [STORE_CONFIG]: { timezone },
  [STORE_APOLLO]: { apolloClient },
  t,
}) => {
  const ComponentToRender = components[name];

  const rawProps = toJS(props);

  // Disable the locale switcher so it doesn't reload the page on preview
  useEffect(() => {
    setContentLocaleChangeHandler(() => {});

    return () => setContentLocaleChangeHandler(null);
  }, []);

  return (
    <Modal
      title={`${t('builder:preview')} ${name} #${id}`}
      show={show}
      onDone={closeModal}
      showCancelButton={false}
      className="previewModal"
    >
      <ContextProvider
        stores={stores}
        timezone={timezone}
        apolloClient={apolloClient}
        weblinkApiConfiguration={{
          uri: builderConfig.graphQLURL,
          portalAuthDomain: builderConfig.portalAuthURL,
        }}
      >
        <ComponentToRender {...rawProps} />
        {(name === 'SearchBar' || name === 'CategoryDropdown') && (
          <div style={{ marginTop: '16px' }}>
            <Prompt
              type="info"
              message={t('builder:extraCataloguePreviewInfo')}
              styleOptions={[UtilityStyle.BottomSpaceMedium]}
            />
            <EmbedNavigation />
          </div>
        )}
      </ContextProvider>
    </Modal>
  );
};

PreviewModal.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(
  inject(STORE_PREVIEW, STORE_CONFIG, STORE_APOLLO)(observer(PreviewModal)),
);
